import { type FC } from "react";
import { OAuthCard } from "@/pages/oauth-consent/oauth-card";

interface OAuthConsentPageFormProps {
  appName: string;
  scopeStr: string;
  accountInfo: {
    profileDisplayName: string;
    profileEmailAddress: string;
    profilePhotoUrl: string | null;
  };
  handleApprove: () => Promise<void>;
  handleDeny: () => Promise<void>;
}

export const OAuthConsentPageForm: FC<OAuthConsentPageFormProps> = ({
  appName,
  scopeStr,
  accountInfo,
  handleApprove,
  handleDeny,
}) => {
  return (
    <OAuthCard
      appName={appName}
      accountInfo={accountInfo}
      scopeStr={scopeStr}
      handleApprove={handleApprove}
      handleDeny={handleDeny}
    />
  );
};
